// extracted by mini-css-extract-plugin
export default {"modalDescription":"EDFFKEjcirOf1htUqt60"};